import React, { useState, Fragment } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { siteUrl } from "../../../utils/siteUrl"

import "./footer.scss"

const Footer = props => {
  const { setCommondModal, mobile } = props

  const [selectCountries, setSelect] = useState(false)

  const resultQuery = useStaticQuery(
    graphql`
      query FOOTER_QUERY {
        allContentfulNolFooter {
          nodes {
            node_locale
            politicaPrivacidadDatos
            terminosYCondiciones
            seccionExtra
            redireccionPoliticaPrivacidadDatos
            redireccionTerminosYCondiciones
            redireccionSeccionExtra
            referenciaPais {
              dominioDelPais
              nombreDelPais
              codigoDeDosLetras
              codigoIcu
              iconoDelPais {
                title
                file {
                  url
                }
              }
            }
            redireccionFacebook
            redireccionInstagram 
            redireccionYoutube
            redireccionSpotify
            redireccionTikTok
          }
        }
      }
    `
  )

  var footerInfo = resultQuery.allContentfulNolFooter.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )[0]

  var activeIconCountryUrl = footerInfo.referenciaPais.filter(
    e => e.codigoIcu === process.env.LOCALE
  )[0].iconoDelPais.file.url
  var activeIconCountryAtl = footerInfo.referenciaPais.filter(
    e => e.codigoIcu === process.env.LOCALE
  )[0].iconoDelPais.title

  var urlFacebook = footerInfo.redireccionFacebook
  var urlInstagram = footerInfo.redireccionInstagram
  var urlYoutube = footerInfo.redireccionYoutube
  var urlSpotify = footerInfo.redireccionSpotify
  var urlTikTok = footerInfo.redireccionTikTok

  var urlPoliticaPrivacidadDatos = footerInfo.redireccionPoliticaPrivacidadDatos
  var urlTerminosCondiciones = footerInfo.redireccionTerminosYCondiciones
  var urlRedireccionSeccionExtra = footerInfo.redireccionSeccionExtra

  var homeLink = siteUrl + "/"

  const handleShowCountriesModal = () => {
    setCommondModal(
      <div className="f-effect-mobile">
        <div className="f-hidden-options">
          <span
            onClick={() => setCommondModal(null)}
            className="f-icon f-icon-close icon2-close"
          />
          <ul className="f-countries-list">
            <li className="f-country-item"></li>
            {!props.mobile ? (
              <span className="f-country-separator"></span>
            ) : null}
            {footerInfo.referenciaPais.map((item, index) => {
              return (
                <Fragment key={index}>
                  <a href={item.dominioDelPais}>
                    <li className="f-country-item">
                      <img
                        src={item.iconoDelPais.file.url}
                        alt={item.iconoDelPais.title}
                        className="f-flag-icon"
                      />
                      <label>{item.nombreDelPais}</label>
                    </li>
                  </a>
                </Fragment>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }

  return (
    <footer className="f-footer">
      <div className="f-footer-container">
        <div className="f-left-footer-section">
          <a
            href={homeLink + urlPoliticaPrivacidadDatos}
            className="f-left-redirect-footer"
          >
            {footerInfo.politicaPrivacidadDatos}
          </a>
          <a
            href={homeLink + urlTerminosCondiciones}
            className="f-left-redirect-footer"
          >
            {footerInfo.terminosYCondiciones}
          </a>
          {footerInfo.seccionExtra !== "contenido-oculto" && (
            <a
              href={homeLink + urlRedireccionSeccionExtra}
              className="f-left-redirect-footer"
            >
              {footerInfo.seccionExtra}
            </a>
          )}
        </div>
        <div className="f-right-footer-section">
          <div
            onClick={() =>
              mobile
                ? handleShowCountriesModal()
                : selectCountries
                ? setSelect(false)
                : setSelect(true)
            }
            className="f-footer-sub-section f-footer-country"
          >
            <img
              src={activeIconCountryUrl}
              alt={activeIconCountryAtl}
              className="f-flag-icon"
            />
            <label className="f-active-country">
              {process.env.COUNTRY_NAME}
            </label>
            <span
              className={
                selectCountries
                  ? "f-icon icon-down f-rotate-colapse"
                  : "f-icon icon-down"
              }
            />
          </div>
          <div className="f-footer-sub-section f-btn-footer-social">
            {process.env.LOCALE !== "es-UY" && urlTikTok && (
              <a href={urlTikTok} target="_blank" rel="noreferrer noopener">
                <span className="f-icon f-footer-icon f-icon-tiktok" />
              </a>
            )}
            {process.env.LOCALE !== "es-UY" && urlFacebook && (
              <a href={urlFacebook} target="_blank" rel="noreferrer noopener">
                <span className="f-icon f-footer-icon f-icon-facebook" />
              </a>
            )}
            {process.env.LOCALE !== "es-UY" && urlInstagram && (
              <a href={urlInstagram} target="_blank" rel="noreferrer noopener">
                <span className="f-icon f-footer-icon f-icon-instagram" />
              </a>
            )}
            
            {process.env.LOCALE !== "es-UY" && urlYoutube && (
              <a href={urlYoutube} target="_blank" rel="noreferrer noopener">
                <span className="f-icon f-footer-icon f-icon-youtube" />
              </a>
            )}
            {process.env.LOCALE !== "es-UY" && urlSpotify && (
              <a href={urlSpotify} target="_blank" rel="noreferrer noopener">
                <span className="f-icon f-footer-icon f-icon-spotify" />
              </a>
            )}
          </div>
        </div>
      </div>

      {selectCountries && (
        <div className="f-effect-mobile">
          <div className="f-hidden-options">
            <span
              onClick={() => setSelect(false)}
              className="f-icon f-icon-close icon2-close"
            />
            <ul className="f-countries-list">
              <li className="f-country-item"></li>

              {footerInfo.referenciaPais.map((item, index) => {
                return (
                  <Fragment key={index}>
                    <a href={item.dominioDelPais}>
                      <li className="f-country-item">
                        <img
                          src={item.iconoDelPais.file.url}
                          alt={item.iconoDelPais.title}
                          className="f-flag-icon"
                        />
                        <label>{item.nombreDelPais}</label>
                      </li>
                    </a>
                  </Fragment>
                )
              })}
            </ul>
          </div>
        </div>
      )}
    </footer>
  )
}

export default Footer